export default __webpack_public_path__ + "static/media/no-submissions.63c2fbd6.svg";